const ro = {
    'Get help': 'Obțineți suport tehnic',
    SEND: 'TRIMITE',
    'Description / Question': 'Descriere / Întrebare',
    'You must complete the field with a question or a bug description!':
        'Trebuie să completați câmpul cu o întrebare sau cu descrierea unui bug!',
    '* When describing a bug, you must present it in as much detail as possible, describe the steps do within the platform until you discover your bug and other relevant details!':
        '* Când descrieți un bug, trebuie să îl prezentați cât mai detaliat posibil, să descrieți pașii făcuți în cadrul platformei până ați descoperit bug-ul și alte detalii relevante!',
    'Bugs / questions sent successfully!': 'Bug-uri / întrebări trimise cu succes!',
};

export default { ro };
